import { createSettingsSelectors } from '@capital-access/common/user';
import { DEFAULT_SECURITY_LIST_KEY } from '../constants';
import { DefaultSecurityListSettings } from '../models';

export const { selectSettings: getDefaultSecurityListSettings } = createSettingsSelectors(
  DefaultSecurityListSettings,
  DEFAULT_SECURITY_LIST_KEY
);
